import React from 'react';
import { InfoTooltip } from './InfoTooltip';
interface FormFieldProps {
  label: string;
  required?: boolean;
  tooltip?: string;
  children: React.ReactNode;
}
export function FormField({
  label,
  required = false,
  tooltip,
  children
}: FormFieldProps) {
  return <div className="mb-4" data-id="element-893">
      <div className="flex items-center mb-1" data-id="element-894">
        <label className="block text-sm font-medium text-gray-700" data-id="element-895">
          {label} {required && <span className="text-red-500" data-id="element-896">*</span>}
        </label>
        {tooltip && <InfoTooltip content={tooltip} data-id="element-897" />}
      </div>
      {children}
    </div>;
}